var Genders;
(function (Genders) {
    Genders["FEMALE"] = "female";
    Genders["MALE"] = "male";
    Genders["UNDETERMINED"] = "undetermined";
})(Genders || (Genders = {}));
export default Genders;
